import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getValidToken } from '../helpers/tokenManager.helper'
import { checkAuthStart, checkAuthSuccess, checkAuthFailure, setAuthenticated } from '../helpers/authActions'

export const useAuth = () => {
  const dispatch = useDispatch()
  const auth = useSelector((state) => state.auth)
  const user = useSelector((state) => state.user)
  const token = useSelector((state) => state.token)

  useEffect(() => {
    // Check authentication on mount if we have a token
    if (token && user && !auth.isAuthenticated) {
      const checkAuth = async () => {
        dispatch(checkAuthStart())

        try {
          const { token: validToken, user: validUser } = await getValidToken()
          dispatch(checkAuthSuccess(validUser, validToken))
        } catch (error) {
          console.error('Auth check failed:', error)
          dispatch(checkAuthFailure())

          // Clear stored data
          dispatch({ type: 'LOGOUT_CLIENT', payload: null })
          dispatch({ type: 'LOGOUT_USER', payload: null })
          dispatch({ type: 'LOGOUT_TOKEN', payload: null })
          dispatch({ type: 'CLEAR_TABLE', payload: null })
          dispatch({ type: 'CLEAR_DOCTORS', payload: null })

          window.localStorage.removeItem('token')
          window.localStorage.removeItem('user')
          window.localStorage.removeItem('client')
        }
      }

      checkAuth()
    } else if (!token && !user) {
      // If no token/user, mark as not authenticated
      dispatch(setAuthenticated(false))
    }
  }, [dispatch, token, user, auth.isAuthenticated])

  return {
    user,
    token,
    isAuthenticated: auth.isAuthenticated,
    isLoading: auth.isLoading,
    error: auth.error
  }
}
